<template>
  <div class="d-flex flex-column">
    <filtered-data
      ref="data"
      v-model="data"
      endpoint="users"
      :filtersValue="filtersValue"
      :loading.sync="loading"
      :sort="sort"
      :hasMore.sync="hasMore"
      :refresh.sync="refresh"
    ></filtered-data>

    <div class="container-fluid">
      <div class="d-flex align-items-center">
        <h1 class="mr-auto">Пользователи</h1>
        <button class="btn btn-primary mx-2" @click="openModal()">Добавить пользователя</button>
        <btn-filters
          :data="data"
          endpoint="users"
          v-model="filtersValue"
        ></btn-filters>
      </div>
    </div>

    <template v-if="data && data.data">
      <data-table-full-height
        :data="data.data"
        :hasMore="hasMore"
        :loading="loading"
        @sort-change="sortChange"
        @load-more="$refs.data.loadMore"
      >
        <el-table-column sortable="keyword" prop="second_name" label="Фамилия"></el-table-column>
        <el-table-column sortable="keyword" prop="first_name" label="Имя"></el-table-column>
        <el-table-column sortable="keyword" prop="third_name" label="Отчество"></el-table-column>
        <el-table-column sortable="keyword" prop="role.label" label="Роль"/>
        <el-table-column sortable="keyword" prop="email" label="E-mail"/>
        <el-table-column sortable="keyword" prop="phone" label="Телефон"/>
        <el-table-column sortable="keyword" prop="region.short_name" label="Организация"/>
        <table-column-date sortable="custom" prop="last_activity_at" label="Последний сеанс" from-now width=""/>
        <el-table-column align="center">
          <template slot-scope="{row}">
            <button class="btn btn-sm btn-outline-light" @click="openModal(row, userId === row.id)">Редактировать</button>
          </template>
        </el-table-column>
        <el-table-column align="center">
          <template slot-scope="{row}">
            <button v-if="userId !== row.id" class="btn btn-sm btn-outline-danger" @click="remove(row)">Удалить</button>
          </template>
        </el-table-column>
      </data-table-full-height>
    </template>
  </div>
</template>

<script>
  import userModal from '../../components/user-modal.vue'
  import api from '@/api'

  export default {
    metaInfo: {title: 'Пользователи'},
    data () {
      return {
        filtersValue: null,
        data: {},
        loading: false,
        sort: null,
        hasMore: true,
        refresh: false,
        userId: this.$root.user.id,
      }
    },
    methods: {
      sortChange (sort) {
        if (sort.prop) {
          const order = sort.order === 'ascending' ? 'asc' : 'desc'
          const keyword = sort.column.sortable === 'keyword' ? '.keyword' : ''
          this.sort = `${sort.prop + keyword}:${order}`
        } else {
          this.sort = null
        }
      },
//      resendPassword (id, email) {
//        if (window.confirm(`Сбросить пароль для ${email}?`)) {
//          return api.put(`auth/resend/${id}`)
//        }
//      },
      openModal (user = null, disableEmail = false) {
        this.$root.showModal(userModal, {
          user,
          disableEmail,
        }).then((data) => {
          if (data && data.refresh) {
            this.refresh = true
          }
        })
      },
      remove (user) {
        if (window.confirm(`Удалить пользователя?`)) {
          return api.delete(`users/${user.id}`).then(() => {
            this.refresh = true
          })
        }
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/settings/users.vue